import * as React from "react";
import Cards, { Focused } from "react-credit-cards";
import "react-credit-cards/lib/styles.scss";
import MaskedInput from "react-text-mask";
import { WaFormFieldConstants } from "./Constants";
import { useWaMembershipFormContext } from "./WaMembershipFormContext";
import { IStepProps } from "./WaMembershipFormStep0";
import { PaypalButton } from "../../PaypalButton";

const WaMembershipFormStep3: React.FC<
	IStepProps & {
		submitForm: () => void;
		contentId: string;
	}
> = (props) => {
	const {
		ccData,
		setCCdata,
		setSubmitDisabled,
		setSubmitClass,
		colorTheme,
		totalDue,
		paypalClientId,
	} = useWaMembershipFormContext();
	const [currentYear, setCurrentYear] = React.useState(0);
	const [currentMonth, setCurrentMonth] = React.useState(0);
	React.useEffect(() => {
		let year = new Date().getFullYear().toString().substr(-2);
		let month = new Date().getMonth() + 1;
		setCurrentYear(Number(year));
		setCurrentMonth(month);
	}, []);

	const [ccNumberError, setCcNumberError] = React.useState(true);
	const [ccExpiryError, setCcExpiryError] = React.useState("");
	const [ccCVCError, setCcCVCError] = React.useState(true);
	const [numberTouched, setNumberTouched] = React.useState(false);
	const [expiryTouched, setExpiryTouched] = React.useState(false);
	const [cvcTouched, setcvcTouched] = React.useState(false);
	const [number, setNumber] = React.useState(0);
	const [expiry, setExpiry] = React.useState("");
	const [cvc, setCVC] = React.useState(0);
	const [focus, setFocus] = React.useState<Focused>("number");
	React.useEffect(() => {
		const paymentInputComplete = checkComplete();
		if (
			paymentInputComplete &&
			(ccData.cvc !== cvc.toString() ||
				ccData.expiry !== expiry.toString() ||
				ccData.number !== number.toString())
		) {
			setCCdata({
				expiry: expiry.toString(),
				cvc: cvc.toString(),
				number: number.toString(),
			});
		}
		if (!paymentInputComplete) {
			setSubmitDisabled(true), setSubmitClass("");
		} else {
			setSubmitDisabled(false), setSubmitClass(colorTheme + "HoverButton");
		}
		setSubmitDisabled(!paymentInputComplete);
	}, [
		ccNumberError,
		ccExpiryError,
		ccCVCError,
		numberTouched,
		expiryTouched,
		cvcTouched,
		ccData,
	]);
	const checkComplete = () => {
		if (
			(ccNumberError && numberTouched) ||
			(ccExpiryError !== "" && expiryTouched) ||
			(ccCVCError && cvcTouched) ||
			!number ||
			!cvc ||
			!expiry
		) {
			return false;
		} else {
			return true;
		}
	};

	const validateSetExpiryDate = (e: React.ChangeEvent<HTMLInputElement>) => {
		if (e.target.value.replace(/\D/g, "").length < 4) {
			setCcExpiryError("Expiry date requires 4 digits MM/YY");
		} else if (Number(e.target.value.replace(/\D/g, "").toString().substr(0, 2)) > 12) {
			setCcExpiryError("Expiry date month cannot be greater than 12");
		} else if (Number(e.target.value.replace(/\D/g, "").toString().substr(-2)) < currentYear) {
			setCcExpiryError("Expiry date cannot be in the past");
		} else if (
			Number(e.target.value.replace(/\D/g, "").toString().substr(-2)) === currentYear &&
			Number(e.target.value.replace(/\D/g, "").toString().substr(0, 2)) < currentMonth
		) {
			setCcExpiryError("Expiry date cannot be in the past");
		} else {
			setCcExpiryError("");
		}
		setExpiry(e.target.value.replace(/\D/g, ""));
	};

	return (
		<div className={"container donStep2"}>
			<h1 className={"donFormHeader donOpposite" + colorTheme}>Payment</h1>
			<p className={"donConfirmAmount donOpposite" + colorTheme}>
				${totalDue && totalDue / 100}
			</p>
			<div className="row justify-content-center">
				<div className="checkout">
					<div className="bPointCardWrapper">
						<Cards
							number={number}
							name={`${props.values[WaFormFieldConstants.firstName]} ${
								props.values[WaFormFieldConstants.lastName]
							}`}
							expiry={expiry}
							cvc={cvc}
							focused={focus}
							callback={(issuer, isValid) => {
								if (!isValid && number) {
									setCcNumberError(true);
								} else {
									setCcNumberError(false);
								}
							}}
						/>
						<div className="bPointCardInputs">
							<MaskedInput
								mask={[
									/\d/,
									/\d/,
									/\d/,
									/\d/,
									" ",
									/\d/,
									/\d/,
									/\d/,
									/\d/,
									" ",
									/\d/,
									/\d/,
									/\d/,
									/\d/,
									" ",
									/\d/,
									/\d/,
									/\d/,
									/\d/,
									" ",
									/\d/,
									/\d/,
									/\d/,
								]}
								name="cardnumber"
								autoComplete="cc-number"
								guide={false}
								className={`bPointField ${
									ccNumberError && numberTouched ? "bPointFieldError" : ""
								}`}
								type="text"
								placeholder="Credit card number"
								onChange={(e) => {
									setNumberTouched(true);
									setFocus("number");
									setNumber(Number(e.target.value.replace(/\D/g, "")));
								}}
							/>
							<MaskedInput
								mask={[/\d/, /\d/, "/", /\d/, /\d/]}
								name="exp-date"
								autoComplete="cc-exp"
								guide={true}
								placeholder="Expiry date"
								className={`bPointField ${
									ccExpiryError && expiryTouched ? "bPointFieldError" : ""
								}`}
								type="text"
								onChange={(e) => {
									setExpiryTouched(true);
									setFocus("expiry");
									validateSetExpiryDate(e);
								}}
							/>
							<MaskedInput
								mask={[/\d/, /\d/, /\d/, /\d/]}
								autoComplete="cc-csc"
								name="cvc"
								guide={false}
								className={`bPointField ${
									ccCVCError && cvcTouched ? "bPointFieldError" : ""
								}`}
								type="text"
								placeholder="CVC"
								onChange={(e) => {
									setcvcTouched(true);
									setFocus("cvc");
									setCVC(Number(e.target.value));
									if (e.target.value.toString().length < 3) {
										setCcCVCError(true);
									} else {
										setCcCVCError(false);
									}
								}}
							/>
						</div>
					</div>
					<div className="bPointError">
						{ccNumberError && numberTouched && <p>Invalid credit card number</p>}
						{ccExpiryError !== "" && expiryTouched && <p>{ccExpiryError}</p>}
						{ccCVCError && cvcTouched && <p>Invalid CVC</p>}
						{!number && !cvc && !expiry && <p>Please enter your card details</p>}
					</div>
					{paypalClientId ? (
						<div key={totalDue}>
							<PaypalButton
								amount={(totalDue / 100)?.toString()}
								contentId={props.contentId}
								disabled={false}
								interval="one"
								paymentProvider="bpoint"
								paypalClientId={paypalClientId}
								setFieldValue={props.setFieldValue}
								submitForm={props.submitForm}
								textColorClass={"donOpposite" + colorTheme}
								transactionDescription="Membership"
							/>
						</div>
					) : null}
				</div>
			</div>
		</div>
	);
};

export default WaMembershipFormStep3;
